import { computed, ref } from 'vue';
import type { ChemicalBrief } from '../../tri-shared/types/tri';
import { actions } from '@/services/actions';
import type { CasOrCategory } from '../../tri-shared/types/db';

export const chemicals = ref<ChemicalBrief[]>([]);
export const chemicalCategories = ref<ChemicalBrief[]>([]);
export const chemicalsAndCategories = computed(() => chemicalCategories.value.concat(chemicals.value));
export const chemicalsByCasOrCategory = ref<Partial<Record<CasOrCategory, ChemicalBrief>>>({});
export const chemicalsToTriCategories = ref<Map<CasOrCategory, CasOrCategory[]>>(new Map());

export async function chemicalsRefresh() {
  const [chemicalsFetched, chemicalCategoriesFetched, chemicalsToTriCategoriesRows] = await Promise.all([
    actions.chemicals.list().catch(() => []),
    actions.chemicals.listCategories().catch(() => []),
    actions.chemicals.listTriCategoryMappings().catch(() => []),
  ]);
  chemicals.value = chemicalsFetched;
  chemicalCategories.value = chemicalCategoriesFetched;

  const asRecord: Partial<Record<CasOrCategory, ChemicalBrief>> = {};
  for (const chem of chemicals.value) {
    asRecord[chem.casOrCategory] = chem;
  }
  for (const chem of chemicalCategories.value) {
    asRecord[chem.casOrCategory] = chem;
  }
  chemicalsByCasOrCategory.value = asRecord;

  chemicalsToTriCategories.value = new Map(chemicalsToTriCategoriesRows.map((r) => [r.cas, r.categories]));
}
